import { TextField as MUITextField, Typography } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import { useAddress } from "components/request-document/components/Address";
import {
  StyleCheckbox,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

const TextField = React.memo(MUITextField);

export default function MedicalExpense({ formik }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);
  const addressFieldOptions = useAddress({ formik });

  const masterData = useSelector(selectMasterData);
  const nationalityConfig = get(masterData, "nationalityConfig", []);

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <Typography style={{ fontWeight: "bold" }}>
                Please select only one{" "}
              </Typography>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.HealthInsurance"
                    checked={formik.values.document.HealthInsurance === "true"}
                    onClick={() => {
                      formik.setFieldValue(
                        "document.HealthInsurance",
                        formik.values.document.HealthInsurance === "true"
                          ? "false"
                          : "true"
                      );
                      formik.setFieldValue(
                        "document.DepositOfNoless",
                        formik.values.document.DepositOfNoless === "false"
                      );
                      formik.setFieldValue(
                        "document.SocialSecurity",
                        formik.values.document.SocialSecurity === "false"
                      );
                    }}
                  />
                }
                label="1. Health insurance policy with a coverage of more than 50,000 USD and with the
                remaining maturity of at least 10 months at the time of application."
              />
              {formik.values.document.HealthInsurance === "true" ? (
                <FormGroup style={{ marginLeft: "50px" }}>
                  <div style={{ display: "flex" }}>
                    <FormControlLabel
                      control={
                        <StyleCheckbox
                          disabled={!canEdit}
                          name="document.Validity"
                          checked={formik.values.document.Validity === "true"}
                          onClick={() => {
                            formik.setFieldValue(
                              "document.Validity",
                              formik.values.document.Validity === "true"
                                ? "false"
                                : "true"
                            );
                          }}
                        />
                      }
                      label="Validity"
                    />
                    <DatePicker
                      // style={{ width: 200 }}
                      className={classes.formControl}
                      inputVariant="outlined"
                      disableFuture={false}
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="Date of issue"
                      views={["year", "month", "date"]}
                      name={`document.ValidityDateIssue`}
                      value={
                        get(
                          formik.values,
                          `document.ValidityDateIssue`,
                          null
                        ) || null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `document.ValidityDateIssue`,
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError(`document.ValidityDateIssue`, formik)}
                      helperText={getErrorMessage(
                        `document.ValidityDateIssue`,
                        formik
                      )}
                      disabled={
                        !canEdit || formik.values.document.Validity === "false"
                      }
                    />
                    <DatePicker
                      // style={{ width: 200 }}
                      className={classes.formControl}
                      inputVariant="outlined"
                      disableFuture={false}
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="Date of expiry"
                      views={["year", "month", "date"]}
                      name={`document.ValidityDateExpiry`}
                      value={
                        get(
                          formik.values,
                          `document.ValidityDateExpiry`,
                          null
                        ) || null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `document.ValidityDateExpiry`,
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError(`document.ValidityDateExpiry`, formik)}
                      helperText={getErrorMessage(
                        `document.ValidityDateExpiry`,
                        formik
                      )}
                      disabled={
                        !canEdit || formik.values.document.Validity === "false"
                      }
                    />
                  </div>
                  <FormControlLabel
                    control={
                      <StyleCheckbox
                        disabled={!canEdit}
                        name="document.SubmitLater"
                        checked={formik.values.document.SubmitLater === "true"}
                        onClick={() => {
                          formik.setFieldValue(
                            "document.SubmitLater",
                            formik.values.document.SubmitLater === "true"
                              ? "false"
                              : "true"
                          );
                        }}
                      />
                    }
                    label="Submit later"
                  />
                </FormGroup>
              ) : null}
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <div style={{ display: "flex" }}>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="document.SocialSecurity"
                      checked={formik.values.document.SocialSecurity === "true"}
                      onClick={() => {
                        formik.setFieldValue(
                          "document.SocialSecurity",
                          formik.values.document.SocialSecurity === "true"
                            ? "false"
                            : "true"
                        );
                        formik.setFieldValue(
                          "document.DepositOfNoless",
                          formik.values.document.DepositOfNoless === "false"
                        );
                        formik.setFieldValue(
                          "document.HealthInsurance",
                          formik.values.document.HealthInsurance === "false"
                        );
                      }}
                    />
                  }
                  label="2. Social security benefits which insures hospitalization and treatment in Thailand"
                />
                {formik.values.document.SocialSecurity === "true" ? (
                  <DatePicker
                    // style={{ width: 200 }}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    format="DD-MM-YYYY"
                    label="Date of expiry"
                    views={["year", "month", "date"]}
                    name={`document.SocialSecurityDate`}
                    value={
                      get(formik.values, `document.SocialSecurityDate`, null) ||
                      null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.SocialSecurityDate`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(`document.SocialSecurityDate`, formik)}
                    helperText={getErrorMessage(
                      `document.SocialSecurityDate`,
                      formik
                    )}
                    disabled={!canEdit}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.DepositOfNoless"
                    checked={formik.values.document.DepositOfNoless === "true"}
                    onClick={() => {
                      formik.setFieldValue(
                        "document.DepositOfNoless",
                        formik.values.document.DepositOfNoless === "true"
                          ? "false"
                          : "true"
                      );
                      formik.setFieldValue(
                        "document.SocialSecurity",
                        formik.values.document.DepositOfNoless === "false"
                      );
                      formik.setFieldValue(
                        "document.HealthInsurance",
                        formik.values.document.DepositOfNoless === "false"
                      );
                    }}
                  />
                }
                label="3. Deposit of no less than 100,000 USD which has been held for no less than 12 months"
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
